export type ConfirmationEmailChoice = "send" | "skip"

export const CONFIRMATION_EMAIL_OPTIONS: Array<{
  value: ConfirmationEmailChoice
  label: string
  name: string
}> = [
  {
    value: "send",
    label: "Terminbestätigung per E-Mail senden",
    name: "Terminbestätigung per E-Mail senden",
  },
  {
    value: "skip",
    label: "Keine Terminbestätigung senden",
    name: "Keine Terminbestätigung senden",
  },
]

